import { action } from 'satcheljs';
import type { CollectionChange } from 'owa-mail-store';

export interface CONVERSATION_READY_TO_LOADActionMessage {
    conversationId: string;
    nodeIdCollectionChange: CollectionChange<string> | undefined;
}
export const conversationReadyToLoad: (
    conversationId: string,
    nodeIdCollectionChange?: CollectionChange<string>
) => CONVERSATION_READY_TO_LOADActionMessage = action(
    'CONVERSATION_READY_TO_LOAD',
    (
        conversationId: string,
        nodeIdCollectionChange?: CollectionChange<string>
    ): CONVERSATION_READY_TO_LOADActionMessage => ({
        conversationId,
        nodeIdCollectionChange,
    })
);

export interface ItemMandatoryPropertiesCollectionChange {
    isReadChangedToUnread: string[];
}

export interface UPDATE_ITEM_MANDATORY_PROPERTIESActionMessage {
    conversationId: string;
    nodeIdCollectionWithItemMandatoryPropertiesChanged: ItemMandatoryPropertiesCollectionChange;
}
export const updateItemMandatoryProperties: (
    conversationId: string,
    nodeIdCollectionWithItemMandatoryPropertiesChanged: ItemMandatoryPropertiesCollectionChange
) => UPDATE_ITEM_MANDATORY_PROPERTIESActionMessage = action(
    'UPDATE_ITEM_MANDATORY_PROPERTIES',
    (
        conversationId: string,
        nodeIdCollectionWithItemMandatoryPropertiesChanged: ItemMandatoryPropertiesCollectionChange
    ): UPDATE_ITEM_MANDATORY_PROPERTIESActionMessage => ({
        conversationId,
        nodeIdCollectionWithItemMandatoryPropertiesChanged,
    })
);
